/**
 * @generated SignedSource<<0e51db43b5ac3ee45e375cb1b0e33654>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TopicDeleteButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type TopicDeleteButtonMutation$data = {
  readonly deleteTopic: string;
};
export type TopicDeleteButtonMutation = {
  response: TopicDeleteButtonMutation$data;
  variables: TopicDeleteButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "deleteTopic",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicDeleteButtonMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "TopicDeleteButtonMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteTopic",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "431c618e34022c775158c0ede2a21323",
    "id": null,
    "metadata": {},
    "name": "TopicDeleteButtonMutation",
    "operationKind": "mutation",
    "text": "mutation TopicDeleteButtonMutation(\n  $id: ID!\n) {\n  deleteTopic(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "d206ac951f14610eb42d855d29195cb3";

export default node;
